export var getCommunicationChartLinkEdgeId = function (link, channel) {
    var lo = Math.min(link.sourceNodeId, link.targetNodeId);
    var hi = Math.max(link.sourceNodeId, link.targetNodeId);
    var hubSuffix = link.hubChatKind !== undefined ? "-".concat(link.hubChatKind) : '';
    return "".concat(lo, "-").concat(hi, "-").concat(channel).concat(hubSuffix);
};
